export function getWindowWidth() {
	const windowWidth = window.innerWidth
	return windowWidth
}

export function getEl(selector, scope = document) {
	return scope.querySelector(selector)
}

export function getEls(selector, scope = document) {
	return Array.from(scope.querySelectorAll(selector))
}

export function getSystemTheme(fallback = 'dark') {
	const supportsMatchMedia = typeof window.matchMedia === 'function'
	if (!supportsMatchMedia) {
		return fallback
	}

	const prefersDark = window.matchMedia(
		'(prefers-color-scheme: dark)'
	).matches
	return prefersDark ? 'dark' : 'light'
}

export function getElHeight(element) {
	if (!element) {
		return 0
	}
	return element.getBoundingClientRect().height
}

export function hasClass(element, className) {
	return Boolean(element) && element.classList.contains(className)
}

export function addClass(element, className) {
	if (!element) {
		return
	}
	element.classList.add(className)
}

export function removeClass(element, className) {
	if (!element) {
		return
	}
	element.classList.remove(className)
}

export function toggleClass(element, className, force) {
	if (!element) {
		return
	}
	element.classList.toggle(className, force)
}

export function hasAttr(element, attribute) {
	return Boolean(element) && element.hasAttribute(attribute)
}

export function getAttr(element, attribute) {
	if (!element) {
		return null
	}
	return element.getAttribute(attribute)
}

export function setAttr(element, attribute, value) {
	if (!element) {
		return
	}
	element.setAttribute(attribute, value)
}

export function removeAttr(element, attribute) {
	if (!element) {
		return
	}
	element.removeAttribute(attribute)
}

export function setText(element, text) {
	if (!element) {
		return
	}
	element.textContent = text
}

export function setHTML(element, html) {
	if (!element) {
		return
	}
	element.innerHTML = html
}

export function isTouchScreen() {
	const hasTouchPoints = navigator.maxTouchPoints > 0
	const hasMsTouchPoints = navigator.msMaxTouchPoints > 0
	if (hasTouchPoints || hasMsTouchPoints) {
		return true
	}

	const coarsePointer = window.matchMedia?.('(pointer:coarse)')
	if (coarsePointer?.matches) {
		return true
	}

	if ('orientation' in window) {
		return true // deprecated but still useful
	}

	// Last resort: user agent sniffing
	const ua = navigator.userAgent
	return /\b(BlackBerry|webOS|iPhone|IEMobile|Android|Windows Phone|iPad|iPod)\b/i.test(
		ua
	)
}
